<template v-if="devTools">
  <li>
    <a href="javascript:void(0);" class="btn btn-lg btn-default" @click="openModel = true">
      <i class="fa fa-cube fa-fw txt-color-red" /> Model
    </a>

    <a href="javascript:void(0);" class="btn btn-lg btn-default" @click="openSchema = true">
      <i class="fa fa-code fa-fw txt-color-red" /> Schema
    </a>

    <span class="text-left" style="width:0;height:0;padding:0;border:0">
      <w-modal class="modal-lg" :open="openModel" title="[SuperAdmin, DEBUG]: Model" @close="openModel = false">
        <template>
          <span class="dev-modals">
            <span>export default {{ model }};</span>

            <input id="hiddenModel" type="hidden" :value="'export default ' + JSON.stringify(model) + ';'" />
          </span>
        </template>

        <template #footerBtn>
          <button type="button" class="btn btn-primary" @click="consoleLog(model, 'model')">
            <i class="fa fa-fw fa-terminal" />
            console.log(model)
          </button>

          <button type="button" class="btn btn-primary" @click="copyToClipboard('hiddenModel')">
            <i class="fa fa-fw fa-clipboard" />
            Kopiuj do schowka
          </button>

          <button type="button" class="btn btn-danger" @click="clearModel(model)">
            <i class="fa fa-fw fa-window-close" />
            Wyczyść Model
          </button>
        </template>
      </w-modal>

      <w-modal class="modal-lg" :open="openSchema" title="[SuperAdmin, DEBUG]: Schema" @close="openSchema = false">
        <template>
          <span class="dev-modals">{{ schemaStr() }}</span>
        </template>

        <template #footerBtn>
          <button type="button" class="btn btn-primary" @click="console.log('schema', schema)">
            <i class="fa fa-fw fa-terminal" />
            console.log(schema)
          </button>
        </template>
      </w-modal>
    </span>
  </li>
</template>
<script>
import WModal from '../modal.vue';
export default {
  name: 'WFormDevTools',
  props: {
    model: Object,
    schema: Object
  },
  data() {
    return {
      devTools: process.env.NODE_ENV === 'development',
      openModel: false,
      openSchema: false
    };
  },
  // mounted() {},

  methods: {
    schemaStr() {
      return JSON.stringify(
        this.schema,
        (key, value) => {
          switch (key) {
            case '$root':
            case '$parent':
            case '_options':
            case '_internal':
              return undefined;
          }
          return value;
        },
        2
      );
    },
    clearModel(model) {
      for (const key in model) {
        if (model == null) {
          continue;
        }

        if (model[key] != null) {
          // clear
          if (typeof model[key] === 'function') {
            continue;
          } else if (Array.isArray(typeof model[key])) {
            model[key] = [];
          } else if (typeof model[key] === 'object') {
            clearModel(model[key]);
          } else if (typeof model[key] === 'string') {
            model[key] = '';
          } else if (typeof model[key] === 'number') {
            model[key] = null;
          }
        }
      }
      // TODO: nie działa this.$set(this, "model", {})
    },
    copyToClipboard(id) {
      console.log(this.model);
      const copyText = document.querySelector('#' + id);
      copyText.setAttribute('type', 'text');
      copyText.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          console.error('copy error', err);
        }
      }
      copyText.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
    consoleLog(model, title) {
      console.log(title ? title + ': ' : 'clicked console log: ', model);
    }
  }
};
</script>
<style scoped>
.dev-modals {
  white-space: pre-wrap; /* CSS3 */
  white-space: -moz-pre-wrap; /* Firefox */
  white-space: -pre-wrap; /* Opera <7 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* IE */
}
</style>
